module.exports = __webpack_public_path__ + "static/img/alipay.1250f78a.jpg";